import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[nipValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: NipValidatorDirective, multi: true}]
})
export class NipValidatorDirective implements Validator {
  constructor() { }
  
  validate(control: AbstractControl): ValidationErrors | null {
    var nip = control.value;
    if (nip == undefined || nip.length != 10)
     return null;
    if (/^\d+$/.test(nip)) {
        let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        let sum = 0;
        let controlNumber = parseInt(nip.substring(9, 10));
    
        for (let i = 0; i < weight.length; i++) {
            sum += (parseInt(nip.substring(i, i + 1)) * weight[i]);
        }
        sum = sum % 11;
        return sum === controlNumber ? null : { nip: true };
    } else
      return null;
    return {nip:true};
  }
}
